import { useEffect } from "react";
import { useSettings } from "../context/SettingsContext";

const loadedFonts = new Set();

function loadGoogleFont(family) {
  if (!family || loadedFonts.has(family)) return;
  loadedFonts.add(family);
  const id = `gf-${family.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/\s+/g, "+")}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}

export default function ThemeInjector() {
  const { settings } = useSettings();

  useEffect(() => {
    const root = document.documentElement;
    const map = {
      "--brand-primary": settings.theme_primary,
      "--brand-primary-hover": settings.theme_primary_hover,
      "--brand-accent": settings.theme_accent,
      "--brand-bg": settings.theme_bg,
      "--header-bg": settings.theme_header_bg,
      "--footer-bg": settings.theme_footer_bg,
      // generic aliases per spec
      "--primary": settings.theme_primary,
      "--accent": settings.theme_accent,
      "--bg": settings.theme_bg,
      "--header-bg-color": settings.theme_header_bg,
      "--footer-bg-color": settings.theme_footer_bg,
    };
    Object.entries(map).forEach(([k, v]) => {
      if (v) root.style.setProperty(k, v);
    });

    if (settings.theme_font_heading) {
      loadGoogleFont(settings.theme_font_heading);
      root.style.setProperty("--font-heading", `'${settings.theme_font_heading}', sans-serif`);
    }
    if (settings.theme_font_body) {
      loadGoogleFont(settings.theme_font_body);
      root.style.setProperty("--font-body", `'${settings.theme_font_body}', sans-serif`);
    }
  }, [settings]);

  return null;
}
